import { Spin, Switch, notification } from 'antd';
import styles from './index.module.sass';
import { RangeItem } from './components/range-item';
import { AddRangeButton } from './components/add-range-button';
import { ButtonMain } from '@/modules/common/components/button';
import { useEffect, useState } from 'react';
import {
  $logisticRanges,
  $logisticRangesLoading,
  ILogisticRange,
  addLogisticRange,
  fetchLogisticRanges,
  setLogisticRanges,
} from '../../store/logistics.store';
import { useStore } from 'effector-react';
import { DiContainer } from '@/modules/di/di-container';
import { LogisticMixingService } from '../../services/logistics-mixing.service';
import { IRangeApiObject } from '../../ts/logistics.types';
const logisticsService = DiContainer.get(LogisticMixingService);

export const LogisticsRightbar = () => {
  const [switchState, setSwitchState] = useState(true);
  const [recalculateTrigger, setRecalculateTrigger] = useState(0);
  const data = useStore($logisticRanges);
  const isLoading = useStore($logisticRangesLoading);

  useEffect(() => {
    fetchLogisticRanges();
  }, []);

  useEffect(() => {
    recalculateBorders(data);
  }, [recalculateTrigger]);

  // console.log(data)

  const handleSave = async ({ data }: { data: ILogisticRange[] }) => {
    const reformedData: IRangeApiObject[] | any = data.map((item) => ({
      range_id: item.id ? item.id : undefined,
      range_start_km: item.start,
      range_end_km: item.border,
      range_price_per_ton: item.priceForPart,
    }));
    try {
      const res = await logisticsService.saveRanges(reformedData);
      notification.success({ message: 'Данные успешно внесены в систему' });
      fetchLogisticRanges();
    } catch (err: any) {
      if (typeof err.error === 'string') {
        notification.error({ message: err.error });
        return;
      }
      if ('errors' in err) {
        let result: string[] = [];

        for (const key in err.errors) {
          if (err.errors.hasOwnProperty(key)) {
            // Объединяем массив ошибок в одно сообщение, если в массиве несколько строк
            result = result.concat(err.errors[key]);
          }
        }
        if (result && result.length > 0) {
          result.map((item) => notification.error({ message: item }));
          return;
        }
        return;
      }
      notification.error({
        message:
          err.message ||
          'Возникла непредвиденная ошибка. Попробуйте, пожалуйста, позже',
      });
    }
  };

  function recalculateBorders(data: ILogisticRange[]) {
    const res: any = [];
    data.reduce(
      (prev: ILogisticRange, current: ILogisticRange) => {
        //return current;
        res.push({ ...current, start: prev.border + 1 });
        return { ...current, start: prev.id === current.id ? 1 : prev.border + 1 };
      },
      { ...data[0] },
    );
    res[0].start = 1;
    setLogisticRanges(res);
  }

  return (
    <div className={styles.root}>
      <div className={styles.topSection}>
        <h3>Стоимость доставки</h3>
        {/* <div className={styles.switcher}>
          <span style={switchState ? { color: '#007E3C' } : {}}>
            {' '}
            {switchState
              ? 'активен для расчетов в системе'
              : 'не активен для расчетов в системе'}
          </span>
          <Switch checked={switchState} onChange={() => setSwitchState(!switchState)} />
        </div> */}
      </div>
      <div className={styles.midSection}>
        <h3>Основные данные</h3>
        {!isLoading.loading && !isLoading.error ? (
          <>
            <ul className={styles.rangesList}>
              {/* <RangeItem key={0} i={0}/>
                    <RangeItem key={1} i={1}/>
                    <RangeItem key={2} i={2}/>
                    <RangeItem key={3} i={3} last={true}/> */}
              {data.map((item, i) => (
                <RangeItem
                  key={i}
                  i={i}
                  id={item.id}
                  begin={item.start}
                  border={item.border}
                  pricePart={item.priceForPart}
                  recalculateBorders={() =>
                    setRecalculateTrigger(recalculateTrigger + 1)
                  }
                />
              ))}
            </ul>
            <AddRangeButton
              label="добавить диапазон"
              onClick={() => {
                if (data.length > 0 && !data[data.length - 1]?.border)
                  return notification.warning({
                    message:
                      'Для добавления нового диапазона, необходимо указать границу предыдущего',
                  });
                addLogisticRange({
                  id: null,
                  start: data[data.length - 1]?.border + 1 || 1,
                  border: 0,
                  priceForPart: 0,
                });
              }}
            />
          </>
        ) : (
          <Spin className={styles.loader} size="large" />
        )}
      </div>
      <div className={styles.bottomSection}>
        <ButtonMain
          className={styles.saveButton}
          onClick={async () => handleSave({ data })}
          label="Сохранить внесенные изменения"
        />
      </div>
    </div>
  );
};
